export default __webpack_public_path__ + "static/media/sagiper-logo.5b68b8f0.svg";